interface Props {
  label: string
  state: boolean
  disabled?: boolean
  onChange: () => void
}

export function Switch({ label, state, onChange, disabled = false }: Props) {
  return (
    <div className="items-center mx-3">
      <label className={`inline-flex items-center ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
        <input
          type="checkbox"
          value=""
          className="sr-only peer"
          onChange={() => !disabled && onChange()}
          checked={state}
          disabled={disabled}
        />
        <div
          className={`relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4
          peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
          peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px]
          after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600
          ${disabled ? 'opacity-50' : ''}`}
        />
        <span className="mx-3 text-sm font-medium text-gray-900">{label}</span>
      </label>
    </div>
  )
}
